document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('scroll-to-lore-btn');
  if (!btn) return;

  const revealIfLoreExists = () => {
    const lore = document.getElementById('lore');
    if (!lore) {
      btn.style.display = 'none';
      return false;
    }

    // Lore exists – show the button
    btn.style.display = 'inline-block';

    // Attach scroll handler once (no duplicate bindings)
    if (!btn.dataset.initialized) {
      btn.dataset.initialized = 'true';

      btn.addEventListener('click', () => {
        if (getComputedStyle(lore).display === 'none') {
          lore.style.display = 'block';
        }

        lore.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    }

    return true;
  };

  // Try immediately
  if (revealIfLoreExists()) return;

  // Fallback if #lore is injected later
  const obs = new MutationObserver(() => {
    if (revealIfLoreExists()) obs.disconnect();
  });
  obs.observe(document.body, { childList: true, subtree: true });

  // Auto-stop after 5s
  setTimeout(() => obs.disconnect(), 5000);
});
